import 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { formatarMilhar } from '../../../utils/formatarMilhar'
import utilsLocalStorage from '../../../utils/localStorage'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'

import NovoPedidoSMS from './novoPedido'

import '../../../css/painelPedidos/pedidosSms/tabela.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let itensVar = []
const valorLimite = 50

function TabelaPedidoSms(props) {
  //HOOKS TABELA
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  const [spinAtivo, setSpinAtivo] = useState(false)
  const despacho = useDispatch()

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)

  let revelarNovoPedidoSMS = useSelector(
    (state) => state.manejadorState.revelarNovoPedidoSMS
  )

  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let revelarCdSms = useSelector((state) => state.manejadorState.exportarCdSms)
  let novoCdSms

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(483) // 'pedidosSmsTabela'
      setColetaUsabilidade(false)
    }
  }, [])

  //Esconde a barra de filtragem
  useEffect(() => {
    if (props.revelarBarraFiltro === true) {
      despacho(revelarBarraFiltragem(false))
    }
    if (props.filtros.vazio != 'vazio') {
      despacho(revelarBarraFiltragem(false))
      despacho(mudarFiltros({ vazio: 'vazio' }))
      despacho(limpadorFiltros(true))
    }
  }, [])

  function getNovoCdSms() {
    if (
      decryptJWT('cdSmsContaUsuario') == undefined ||
      decryptJWT('cdSmsContaUsuario') == 'undefined'
    ) {
      if (revelarCdSms) {
        utilsLocalStorage.setCdSmsContaUsuario(revelarCdSms)
        return revelarCdSms
      } else {
        return utilsLocalStorage.getCdSmsContaUsuario()
      }
    } else {
      return decryptJWT('cdSmsContaUsuario')
    }
  }

  useEffect(() => {
    setSpinAtivo(true)
    //despacho redux
    despacho(mudarManejador('novoPedidoSMS'))
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
    novoCdSms = getNovoCdSms()

    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()
          const { data } = await api_gateway.get(
            '/m1/consultar/sms_pedido?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca +
              '&sms9.cd_sms_conta_usuario=' +
              novoCdSms
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          'sms9.cd_sms_conta_usuario': novoCdSms
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/sms_pedido',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/sms_pedido?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&sms9.cd_sms_conta_usuario=' +
              novoCdSms
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    novoCdSms = getNovoCdSms()

    if (controladorPagina <= paginaAtual && filtros.vazio) {
      apiData = await api_gateway.get(
        '/m1/consultar/sms_pedido?contar=true&buscar=' +
          conteudoBusca +
          '&sms9.cd_sms_conta_usuario=' +
          novoCdSms
      )
    } else {
      const dados = {
        paguinaAtual: contador,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        contar: true,
        filtros: filtros,
        'sms9.cd_sms_conta_usuario': novoCdSms
      }
      apiData = await api_gateway.post('/m1/filtrar/sms_pedido', dados)
    }
    itensVar = []
    if (apiData.data.dados) {
      totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
      totalItens = apiData.data.dados[0].CONTADOR
      for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
        arrayItens.push(i)
      }
      itensVar = arrayItens
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      setRenderizar(!renderizar)
      restaurarConfigsIniciaisPagina()
    }
  }

  const colunas = [
    {
      dataField: 'NUMERO_PEDIDO',
      text: 'Pedido',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DATA_PEDIDO',
      headerClasses: 'nao-selecionavel',
      text: 'Data',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'PEDIDO_STATUS',
      headerClasses: 'nao-selecionavel',
      text: 'Status',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'USUARIO_EMAIL',
      headerClasses: 'nao-selecionavel',
      text: 'Usuário',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'QTD_SMS',
      headerClasses: 'nao-selecionavel',
      text: 'Quantidade de SMS',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'VALOR',
      headerClasses: 'nao-selecionavel',
      text: 'Valor',
      sort: true,

      formatter: (cell) => {
        const valor = parseFloat(cell)
        return (
          <p className="fonte-cor-1 label-tabela-1 container-valor-pedidosSimcard">
            {' '}
            {!valor || isNaN(valor) ? (
              <>
                <p className="valor-rs-pedidosSimcard2">R$</p>{' '}
                <p className="fonte-cor-1 valor-pedidosSimcard3"> 0.00 </p>
              </>
            ) : (
              <>
                <p className="valor-rs-pedidosSimcard2">R$</p>{' '}
                <p className="fonte-cor-1 valor-pedidosSimcard3">
                  {' '}
                  {formatarMilhar(valor)}
                </p>
              </>
            )}{' '}
          </p>
        )
      }
    }
  ]

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  return (
    <div className="container-tela">
      <Table
        keyField="NUMERO_PEDIDO"
        clickToSelect
        revelarContador
        spinAtivo={spinAtivo}
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}

      {revelarNovoPedidoSMS === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovoPedidoSMS
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="As Mensagens foram atualizadas."
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(TabelaPedidoSms))
